<template>
  <div class="pinned-event">

    <div v-if="language === 'en-US'" class="alert alert-info"><img id="blogLangSry" src="/img/icons/cz.svg" alt="Czech"> We are sorry, but the our story is currently available only in czech language.</div>

    <div class="pinned-event__header">
      <div class="pinned-event__header__date">
        {{ event.pinnedDate || event.date }}
      </div>
      <div class="pinned-event__header__top-button">
        <StarIcon star-icon-class="pinned-event__header__top-button__icon" />
        top
      </div>
    </div>
    <div class="pinned-event__title">
      {{ event.pinnedTitle }}
    </div>
    <div v-if="event.pinnedDescription" class="pinned-event__description">
      {{ event.pinnedDescription }}
    </div>
    <Button v-bind:on-click="onClick" button-class="pinned-event__button">
      {{ $t('dej-mi-vic') }}
    </Button>
  </div>
</template>

<script>
  import Button from '@/components/Button';
  import { EventType } from '@/components/Event';
  import StarIcon from '@/components/StarIcon';

  export default {
    name: 'PinnedEvent',
    components: {
      StarIcon,
      Button,
    },
    props: {
      event: EventType,
      language: {
        type: String,
        required: true
      }
    },
    methods: {
      onClick() {
        if (this.event.id) {
          const element = document.querySelector(`#${this.event.id}`);
          if (element) {
            const position = element.getBoundingClientRect();
            window.scrollTo({
              top: position.top + window.scrollY - 75,
              behavior: 'smooth'
            });
          }
        }
      }
    }
  };
</script>

<style lang="scss">
  @import '@/styles/variables.scss';
  @import '@/styles/functions.scss';

  .pinned-event {
    color: white;
    padding: 16px;
    background-color: $mediumWhite;
    border-radius: 16px;

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 4px;

      &__date {
        color: $damiGrass;
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: bold;
        font-size: 12px;
        line-height: 14px;
        letter-spacing: 0.3em;
        text-transform: uppercase;
      }

      &__top-button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px 12px;
        background: $mediumWhite;
        border-radius: 6px;
        font-family: 'Roboto Condensed', sans-serif;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.3em;
        text-transform: uppercase;


        &__icon {
          margin-right: 12px;
        }
      }
    }

    &__title {
      font-family: 'Zilla Slab', sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 29px;
      margin-bottom: 16px;
    }

    &__description {
      font-size: 15px;
      line-height: 140%;
      margin-bottom: 16px;
    }

    @include media-breakpoint-up(md) {
      padding: 40px;

      &__header {
        margin-bottom: 8.5px;

        &__date {
          font-size: 16px;
          line-height: 19px;
        }

        &__top-button {
          padding: 6px 18px;
          font-size: 12px;
          line-height: 14px;
        }
      }

      &__title {
        font-size: 32px;
        line-height: 38px;
        margin-bottom: 24px;
      }

      &__description {
        font-size: 16px;
        line-height: 150%;
        margin-bottom: 24px;
      }

      &__button {
        max-width: 247px;
      }
    }
  }
</style>
